module.exports = __webpack_public_path__ + "img/TailWing-User_II.5ea35cbc.jpg";